"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRoveFocus = void 0;
var react_1 = require("react");
var useRoveFocus = function (size, elementRef, defaultFocusIndex) {
    if (defaultFocusIndex === void 0) { defaultFocusIndex = 0; }
    var _a = (0, react_1.useState)(defaultFocusIndex), currentFocus = _a[0], setCurrentFocus = _a[1];
    var handleKeyDown = (0, react_1.useCallback)(function (e) {
        if (e.key === 'ArrowDown') {
            e.preventDefault();
            setCurrentFocus(currentFocus === size - 1 ? 0 : currentFocus + 1);
        }
        else if (e.key === 'ArrowUp') {
            e.preventDefault();
            setCurrentFocus(currentFocus === 0 ? size - 1 : currentFocus - 1);
        }
    }, [size, currentFocus, setCurrentFocus]);
    (0, react_1.useEffect)(function () {
        var element = elementRef.current;
        element.addEventListener('keydown', handleKeyDown, false);
        return function () {
            element.removeEventListener('keydown', handleKeyDown, false);
        };
    }, [handleKeyDown, elementRef]);
    return [currentFocus, setCurrentFocus];
};
exports.useRoveFocus = useRoveFocus;
